"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.apiCallFactory = exports.addCommandNameToParameterObject = exports.generateRequestId = void 0;
/**
 * Generate random request IDs for API calls to distinguish
 * between different requests.
 */
const generateRequestId = () => {
    var requestIdBytes;
    if (typeof window !== "undefined" && window.crypto) {
        requestIdBytes = new Uint8Array(20);
        crypto.getRandomValues(requestIdBytes);
    }
    else {
        throw "Need to mock window.crypto.getRandomValues()";
    }
    return [...requestIdBytes].map(byte => byte.toString(16)).join("");
};
exports.generateRequestId = generateRequestId;
/**
 * An API request object is just a set of parameters with the function (command)
 * name attached.  This function adds the commands to the parameters to create
 * a request that can be sent over the wire.
 *
 * @param command The API call name.
 * @param parameters The parameters to that API call.
 */
const addCommandNameToParameterObject = (command, parameters) => (Object.assign(Object.assign({}, parameters), { command }));
exports.addCommandNameToParameterObject = addCommandNameToParameterObject;
/**
 * This factory creates an API call from the name of the API command
 * and a generic function for sending API requests and handling the
 * responses.
 *
 * @param command The API call name.
 * @param client An API client function that implements generic marshalling
 * of the request object and response object and sends the call
 */
const apiCallFactory = (command, client) => (parameters) => client((0, exports.addCommandNameToParameterObject)(command, parameters));
exports.apiCallFactory = apiCallFactory;
//# sourceMappingURL=api-factory.js.map